module.exports = __webpack_public_path__ + "static/minotaur-bcbb118cd88bcd70ecf69c8486296b05.jpeg";